import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { updateTextInput } from "../../../actions";
import markdownIt from 'markdown-it';
import mila from "markdown-it-link-attributes";

let md = markdownIt({ html: false, linkify: true, typographer: true, breaks: false });
md.use(mila, { attrs: { target: "_blank", rel: "noopener", } });

export default function MultiSelect(props: any) {
	const design = useSelector((state: any) => state?.design);
	const dispatch = useDispatch();
	const { message, currentIndex, count, topMargin } = props;
	const [options, setOptions] = useState([
		{ value: 'Option 1', status: false },
	]);

	const [selectedOptions, setSelectedOptions] = useState<any>([]);

	useEffect(() => {
		setOptions(() => message.options);
	}, [message.options]);

	const handleMultipleChoice = (option: any) => {
		let newOptions: any = [];

		if (selectedOptions.includes(option.value)) {
			const filteredOptions = selectedOptions.filter((item: string) => item !== option.value)
			setSelectedOptions(filteredOptions);
			newOptions = filteredOptions;

		} else {
			newOptions = [...selectedOptions, option.value];
			setSelectedOptions(newOptions);
		}
		dispatch(updateTextInput({
			value: newOptions.join(', ')
		})
		);
	}

	return <>
		<div className="ele-multi-select max-w-80 w-fit">
			<div className={`ele-multi-select-message-label rounded-tl-xl rounded-tr-xl py-2 px-4 bg-primaryBgColor ${topMargin}`}>
				<p className="prose" dangerouslySetInnerHTML={{ __html: md.render(message.label) }} />
			</div>
			{
				(currentIndex === (count - 1) && (
					<div className="options-container  border-solid border-2 border-t-0 border-primaryBgColor rounded-bl-xl rounded-br-xl">
						{
							options.map((option, index) => {
								return <div
									onClick={(e) => handleMultipleChoice(option)}
									key={index + option.value}
									className={`ele-bubble-multiselect option cursor-pointer hover:bg-primaryBgColor flex justify-between p-2 items-center border-solid border-t-2 border-primaryBgColor ${index === options.length - 1 ? 'hover:rounded-b-lg' : ''}`}>
									<p className="text-primaryColor" style={{ color: design?.themeColor }}>{option.value}</p>
									<input id="link-checkbox" type="checkbox" checked={selectedOptions.includes(option.value)} style={{ accentColor: design?.themeColor }}
										className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded dark:bg-gray-700 dark:border-gray-600 focus:outline-none cursor-pointer ml-2.5"
										onChange={e => { return false }} />
								</div>
							})
						}
					</div>
				))
			}

		</div>
	</>
}
